export const uiCookieBanner = {
    name: 'UI Cookie Banner',
    description: '',
    displayField: 'bannerText',
    fields: {
        bannerText: {
            name: 'Banner Text',
            type: 'Text',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        acceptCookieText: {
            name: 'Accept Cookie Text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        cookiePreferences: {
            name: 'Cookie Preferences',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiCookiePreferences'] }]
        }
    }
};
//# sourceMappingURL=uiCookieBanner.js.map